import React, { Component } from 'react';
import * as API from '../../api.js';
import Loader from '../../icons/loader.svg';
import Avatar from 'react-avatar';
import validator from 'validator';
import { AnimatedModal } from '../../ReusableComponents/AnimatedModal.js';
import { connect } from "react-redux";
import { updateProfileDetails } from '../../redux/index.js';
import { addUserAnalytic, checkSubscriptionAndStorage, Popup, updateOutTime } from '../../ReusableComponents/reusableFunctions.js';
import { ActivityPopup } from '../../ReusableComponents/ActivityPopup.js';
import { getActiveTeam } from '../../Teams/index.js';
import NoTeamMember from "../../assets/Icons/NoTeamMember.png";
import AppConstants from '../../AppConstants.js';
import dateFormat from 'dateformat';
import teamsGreenTick from "../../icons/teamsGreenTick.svg"
import teamsDeleteIcon from "../../icons/teamsDeleteIcon.svg"
import teamsInvite from "../../icons/teamsInvite.svg"
import Viewbuttons from '../../ReusableComponents/SearchHeader/ViewButtons.js';
import Button from '../../ReusableComponents/Button/Button.js';
import TableView from '../../ReusableComponents/TableView/TableView.js';
import closeBtn from "../../icons/close.png"
import SubscriptionExpireModal from '../../subscription/Reusable/SubscriptionExpireModal.js';
import TableViewPagination from '../../ReusableComponents/TableView/TableViewPagination.js';
import { v4 as uuidv4 } from 'uuid';
class AeroGCSEnterpriseTeam extends Component {
    fileInputRef = React.createRef();
    state = {
        inviteMail: "",
        inviteModal: false,
        addPilotModal: false,
        pilotName: '',
        pilotMobile: '',
        pilotLicense: '',
        validationColor: 'red',
        user: {},
        type: "",
        loading: true,
        showBackIcon: true,
        sidebarMode: (this.props.location.state ? this.props.location.state.sidebarMode : "shrunk"),
        validationDisplay: "none",
        validationMessage: "",
        teamsList: [],
        list: [],
        activeTeam: "",
        teamUsers: [],
        isUserTeamOwner: false,
        deleteUserName: "",
        teamLoading: true,
        subscriptionPlan: '',
        subcheck: false,
        itemName: "",
        showProcessPopup: false,
        processPopupIcon: "",
        processAction: "",
        processMessage: "",
        outId: "",
        listView: true,
        listViewPilot: true,
        showSubscriptionExpirePopup: false,
        currentPageMembers: 1,
        currentPagePilots: 1,
        pageSize: 15,
        isPilotsLoading: true,
        dronePilotsList: [],
        updatePilotModal: false,
        deleteUserId: '',
        initialPilotData: {
            name: "",
            mobile: "",
            license: ""
        },
        updateFormErrors: {
            name: "",
            mobile: "",
            license: ""
        },
        errors: {
            name: "",
            mobile: "",
            license: ""
        },
        otpError: '',
        pilotMobileVerified: false,
        showOtpModal: false,
        otp: '',
        isMobileChanged: false,
        tempPilotId: '',
        isSendingOtp: false,
        isVerifyingOtp: false,
        team: null,
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.addPilotModal !== this.state.addPilotModal) {
            this.setState({
                pilotName: '',
                pilotMobile: '',
                pilotLicense: '',
            });
        }
    }


    handleMemberPageChange = (page) => {
        this.setState({ currentPageMembers: page });
    };

    handleFileImport = () => {
        this.fileInputRef.current.click();
    }
    generateTempId = () => {
        return uuidv4();
    }

    handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append("pilotcsv", file);
            Popup.alert('WAIT', 'Import csv data ...')
            try {
                const res = await API.uploadPilotCSV(formData);
                Popup.alert('COMPLETE', 'Data imported successfully !')
                this.handleGetAllDronePilots();
            } catch (err) {
                Popup.alert('ERROR', err?.message || "something went wrong while import csv data");
            } finally {
                if (this.fileInputRef.current) {
                    this.fileInputRef.current.value = '';
                }
            }

        }
    };


    handlePilotPageChange = (page) => {
        this.setState({ currentPagePilots: page });
    };

    canUpdatePilot = () => {
        const { pilotName, pilotMobile, pilotLicense, updateFormErrors, initialPilotData, pilotMobileVerified, isMobileChanged } = this.state;

        // Check if required fields are filled
        const requiredFieldsFilled = pilotName.trim() && pilotMobile.trim();

        // Check if there are any validation errors
        const hasErrors = Object.values(updateFormErrors).some(error => error !== "");

        // Check if any values have changed
        const valuesChanged =
            pilotName !== initialPilotData.name ||
            pilotMobile !== initialPilotData.mobile ||
            (pilotLicense || "") !== initialPilotData.license;

        const mobileVerificationRequired = isMobileChanged;
        const mobileVerified = mobileVerificationRequired ? pilotMobileVerified : true;
        return requiredFieldsFilled && !hasErrors && valuesChanged && mobileVerified;
    }

    getMemberPaginatedData = () => {
        const { currentPageMembers, pageSize, teamUsers } = this.state;
        const startIndex = (currentPageMembers - 1) * pageSize;
        return (teamUsers || []).slice(startIndex, startIndex + pageSize);
    };

    getPilotPaginatedData = () => {
        const { currentPagePilots, pageSize, dronePilotsList } = this.state;
        const startIndex = (currentPagePilots - 1) * pageSize;
        return (dronePilotsList || []);
        // return (dronePilotsList || []).slice(startIndex, startIndex + pageSize);
    };


    parentSidebarSwitch = () => {
        this.setState((state) => ({
            ...state,
            sidebarMode: (state.sidebarMode == "shrunk" ? "expanded" : "shrunk")
        }))
    }

    closeActivityPopup = () => {
        this.setState((state) => ({
            ...state,
            showProcessPopup: false,
            processMessage: null
        }))
    }

    handleInputChange = (event, state) => {
        this.setState({
            [state]: event.target.value
        })
    }

    validateLicense = (license) => {
        if (license.length > 0 && (license.length < 3 || license.length > 15)) {
            return "License number should be between 3-15 characters";
        }
        return "";
    }

    validateMobile = (mobile) => {
        if (mobile.length < 10) {
            return "Mobile Number should be 10 digits"
        }
        return "";
    }

    validatePilotName = (name) => {
        if (name.length < 3) {
            return "Pilot name should be minimum 3 characters long "
        }
        return "";
    }

    isFormFilled = () => {
        let isAnyErrors = Object.values(this.state.errors).some(error => error !== "");
        let isAnyEmptyValues = !this.state.pilotName || !this.state.pilotMobile;
        return !isAnyErrors && !isAnyEmptyValues && this.state.pilotMobileVerified;
    }

    getTeamUsers = () => {
        const { activeTeam } = this.state;
        API.getTeamUsers(activeTeam.teamId).then((response) => {
            this.setState((state) => ({
                ...state,
                teamUsers: response?.teamMembers?.sort((a, b) => a.userFullName < b.userFullName ? -1 : (a.userFullName > b.userFullName ? 1 : 0)) || [],
                loading: false,
                teamLoading: false,
            }))
        })
            .catch((error) => {
            })
    };

    handleChange = (team) => {
        this.setState({
            activeTeam: team,
            teamLoading: true
        }, () => {
            this.getTeamUsers();
        })
    }

    deleteUserFromTeam = (username, name, userId) => {
        this.setState((prevState) => ({
            ...prevState,
            itemName: "Team member",
            processPopupIcon: "WARNING",
            processAction: "DELETE",
            processMessage: "Are you sure you want to delete this team member?",
            showProcessPopup: true,
            deleteUser: username,
            deleteUserName: name ? name : username,
            deleteUserId: userId
        }))
    }

    deleteUserConfirm = () => {
        const { activeTeam, deleteUser } = this.state
        this.setState((prevState) => ({
            ...prevState,
            itemName: "Team member",
            processPopupIcon: "WAIT",
            processAction: "DELETE",
            processMessage: "Removing Member, Please Wait...",
            showProcessPopup: true,
            deleteUser: "",
            teamLoading: true,
        }))
        API.deleteUserFromTeam(activeTeam.teamId, deleteUser, this.state.deleteUserId).then((response) => {
            this.setState((state) => ({
                itemName: "Team member",
                processPopupIcon: "COMPLETE",
                processAction: "DELETE",
                processMessage: `Removed '${this.state.deleteUserName}' from your team.`,
                showProcessPopup: true,
            }), () => {
                this.getTeamUsers()
            })
        }, (e) => {
            this.setState((state) => ({
                itemName: "Team member",
                processPopupIcon: "ERROR",
                processAction: "DELETE",
                processMessage: e,
                showProcessPopup: true,
            }))
        })
    }

    sendInvite = () => {
        const { inviteMail, user, activeTeam } = this.state
        if (inviteMail === user.username) {
            this.setState((prevState) => ({
                ...prevState,
                validationDisplay: "block",
                validationColor: "red",
                validationMessage: "You can not send invitation to yourself."
            }))
        } else if (inviteMail === "") {
            this.setState((prevState) => ({
                ...prevState,
                validationDisplay: "block",
                validationColor: "red",
                validationMessage: "Please fill email to send invitation."
            }))
        } else if (validator.isEmail(inviteMail)) {
            API.inviteUserToTeam(inviteMail, activeTeam.teamId)
                .then((response) => {
                    if (response.status === 201) {
                        this.getTeamUsers()
                        this.setState((prevState) => ({
                            ...prevState,
                            inviteModal: false,
                            validationDisplay: "none",
                            validationMessage: "",
                            inviteMail: "",
                            teamLoading: "true"
                        }))
                    } else {
                        response.json().then((data) => {
                            this.setState((prevState) => ({
                                ...prevState,
                                validationDisplay: "block",
                                validationMessage: data.message,
                                validationColor: "red"
                            }))
                        })
                    }
                })
                .catch((error) => {
                    this.setState((prevState) => ({
                        ...prevState,
                        validationDisplay: "block",
                        validationMessage: error.Error,
                        validationColor: "red"
                    }))
                })

        } else {
            this.setState((prevState) => ({
                ...prevState,
                validationDisplay: "block",
                validationColor: "red",
                validationMessage: "Enter valid email address."

            }))
        }
    };

    getTeamsList = () => {
        API.getTeamsList().then((teams) => {
            this.setState((state) => ({
                ...state,
                activeTeam: teams.teams.find(team => team.isOwner),
                teamsList: teams.teams
            }), () => {
                this.getTeamUsers()
            })
        })
            .catch((error) => {
                console.log(error);
            })
    };

    handleGetAllDronePilots = async () => {
        const {
            dronePilotsPageNumber,
            dronePilotsPageSize,
            dronePilotsOrderType,
            dronePilotsOrderBy,
            dronePilotsSearchQuery
        } = this.state;

        try {
            const response = await API.getAllDronePilots({
                pageNumber: dronePilotsPageNumber || 1,
                pageSize: dronePilotsPageSize || 1000,
                orderType: dronePilotsOrderType || "DESC",
                orderBy: dronePilotsOrderBy || "date_created",
                searchQuery: dronePilotsSearchQuery || "",
            });

            this.setState({
                dronePilotsList: response.dronePilots || [],
                isPilotsLoading: false,
            });

        } catch (error) {
            this.setState({ isPilotsLoading: false });

            Popup.alert("ERROR", error.message || "Failed to fetch drone pilots.");
        }
    };


    handleAddPilotSubmit = async () => {
        const { pilotName, pilotMobile, pilotLicense, tempPilotId } = this.state;
        try {
            Popup.alert("WAIT", "Adding pilot, please wait...");

            const response = await API.addNewDronePilot(tempPilotId, pilotName, pilotMobile, pilotLicense);

            this.setState({
                pilotName: '',
                pilotMobile: '',
                pilotLicense: '',
                addPilotModal: false,
                validationMessage: '',
                tempPilotId: '',
                otpError: '',
                pilotMobileVerified: false,
                otp: '',
                isSendingOtp: false,
                isVerifyingOtp: false
            });
            this.handleGetAllDronePilots();
            Popup.alert("COMPLETE", `${response.dronePilot.pilot_name} has been successfully added as a pilot.`);

        } catch (error) {
            Popup.alert("ERROR", error.message || "An error occurred while adding the pilot.");
        }
    };

    handlePilotUpdate = async () => {
        const {
            pilotId,
            pilotName,
            pilotMobile,
            pilotLicense,
        } = this.state;


        try {
            Popup.alert("WAIT", "Updating pilot information, please wait...");

            const result = await API.updateDronePilot(pilotId, {
                name: pilotName,
                mobile_no: pilotMobile,
                license_id: pilotLicense || "",
            });

            Popup.alert("COMPLETE", `${result.pilot.pilot_name} has been updated successfully.`);

            this.setState({
                pilotName: '',
                pilotMobile: '',
                pilotLicense: '',
                pilotId: '',
                updatePilotModal: false,
                validationMessage: '',
            });

            this.handleGetAllDronePilots();

        } catch (error) {
            this.setState({
                pilotMobileVerified: false
            });
            Popup.alert("ERROR", error.message || "Failed to update the drone pilot. Please try again.");
        }
    };

    handleVerifyOtp = async (otp, pilotId) => {

        if (!otp || otp.length !== 6) {
            this.setState({
                otpError: "Please enter a valid 6-digit OTP",
            });
            return;
        }

        try {
            this.setState({
                isVerifyingOtp: true,
                otpError: '' // Clear previous errors
            });

            // Call API to verify OTP
            await API.verifyPilotOtp({
                pilot_id: pilotId,
                otp: otp
            });

            this.setState({
                pilotMobileVerified: true,
                showOtpModal: false,
                isVerifyingOtp: false,
                otp: '',
                otpError: ''
            });
            Popup.alert("COMPLETE", "OTP verified successfully");
        } catch (error) {
            this.setState({
                isVerifyingOtp: false,
                otpError: error.message || "Invalid OTP. Please try again."
            });
        }
    }

    handleSendOtp = async (mobileNumber, tempId = null) => {
        const tempPilotId = tempId || this.generateTempId();
        this.setState({
            showOtpModal: true,
            otpError: '',
            tempPilotId
        });

        try {
            this.setState({ isSendingOtp: true });
            // Call API to send OTP
            await API.sendOtpToPilot({
                mobile_number: mobileNumber,
                pilot_id: tempPilotId
            });

            this.setState({
                isSendingOtp: false,
            });
            Popup.alert("COMPLETE", "OTP sent successfully to your mobile number.");
        } catch (error) {
            this.setState({
                isSendingOtp: false,
            });
            Popup.alert("ERROR", error.message || "Failed to send OTP. Please try again.");
        }
    }


    componentWillUnmount() { updateOutTime(this.state.outId) }

    componentWillMount() {
        document.title = "Manage Teams";
        getActiveTeam().then(activeTeam => {
            this.setState({
                team: activeTeam
            }, () => {
                this.handleGetAllDronePilots();
                addUserAnalytic(this.props.location.pathname).then(id => this.setState({ outId: id }))
                checkSubscriptionAndStorage(AppConstants.SERVICES.AEROGCS).then(data => {
                    if (data.error || data.storageExceed || data.subscriptionExpire || !data.isValidStoragePlan || data.isExpired) this.setState({ showSubscriptionExpirePopup: { ...data, user: this.props?.location?.state?.user } });
                    else this.setState({ showSubscriptionExpirePopup: false, infoPopup: true });
                })
                if (this.props.location.state) {
                    let { user, type } = this.props.location.state;
                    this.setState((state) => ({
                        ...state,
                        user,
                        type,
                    }), () => { this.getTeamsList(); })
                } else {
                    API.getUserType().then(([blah, type, user]) => {
                        this.setState((state) => ({
                            ...state,
                            user,
                            type,
                        }), () => { this.getTeamsList(); })
                    }, (e) => { window.location.replace("/login"); }
                    )
                }

            })
        })
    }

    render() {
        let { user, type, inviteModal, addPilotModal, validationMessage, validationColor, teamUsers } = this.state
        return (
            <>
                {user.username ?
                    <div className="wrapper">
                        <div className="right-content-new"
                            onClick={
                                () => {
                                    this.setState((state) => ({ ...state, sidebarMode: 'shrunk' }))
                                }
                            }
                        >
                            {
                                this.state.showSubscriptionExpirePopup ?
                                    <SubscriptionExpireModal
                                        data={this.state.showSubscriptionExpirePopup}
                                    /> : <></>
                            }
                            <div className="top-bar-new">
                                <div className="top-bar-text-new">
                                    Teams
                                </div>
                            </div>
                            {this.state.loading ?
                                <div style={{ height: "85vh", width: "91vw", display: "flex", textAlign: "center" }}>
                                    <img src={Loader} style={{ height: "30vh", width: "100vw", margin: "auto" }} />
                                </div> :
                                <div className="main-content-new team" style={{ background: 'none', padding: "2vh 6%", }} onClick={
                                    () => {
                                        this.setState((state) => ({
                                            ...state, sidebarMode: 'shrunk'
                                        }))
                                    }
                                }>
                                    {this.state.team.isOwner ?
                                        <>
                                            <div style={{ maxHeight: '44vh', height: '44vh', display: 'flex', flexDirection: 'column' }}>
                                                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", textAlign: "center", marginBottom: '20px' }}>
                                                    <div className="teamName total-team-members">
                                                        {`Total Members(${teamUsers.length})`}
                                                    </div>
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px" }}>
                                                        <Button
                                                            className={"new-btn-lg"}
                                                            text={"Invite"}
                                                            isBtnActive
                                                            isDisabled={!this.state.activeTeam.isOwner}
                                                            onClick={() => {
                                                                this.setState({
                                                                    inviteModal: true,
                                                                    inviteMail: "",
                                                                    validationDisplay: "none",
                                                                    validationColor: "red",
                                                                    validationMessage: ""
                                                                })
                                                            }}
                                                        />
                                                        <Viewbuttons
                                                            globalState={{ selectView: this.state.listView ? 'list' : "grid" }}
                                                            handleStateChange={(selectView, view) => {
                                                                this.setState({ listView: view === 'list' });
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <ActivityPopup
                                                    item={this.state.itemName}
                                                    open={this.state.showProcessPopup}
                                                    icon={this.state.processPopupIcon}
                                                    action={this.state.processAction}
                                                    msg={this.state.processMessage}
                                                    close={() => this.closeActivityPopup()}
                                                    onClickOk={() => this.deleteUserConfirm()}
                                                />

                                                {this.state.teamLoading ? (
                                                    <div style={{ height: "70vh", display: "flex", textAlign: "center" }}>
                                                        <img src={Loader} style={{ height: "30vh", margin: "auto" }} />
                                                    </div>
                                                ) : (
                                                    <>
                                                        {teamUsers.length > 0 ? (
                                                            this.state.listView ? (
                                                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                                                    <div style={{ flex: 1, overflowY: 'auto', position: "relative" }}
                                                                        onScroll={(e) => {
                                                                            const menus = document.querySelectorAll('[data-tippy-root]');
                                                                            menus.forEach(menu => menu.remove());
                                                                        }}>
                                                                        <TableView
                                                                            count={0}
                                                                            showSrNo={true}
                                                                            onStateChange={() => { }}
                                                                            headingLeft={""}
                                                                            onClickRow={(row) => {
                                                                                if (row.isActive) {
                                                                                    this.props.history.push("/teams/givenAccess", {
                                                                                        teamUser: {
                                                                                            ...row,
                                                                                            status: row.isActive ? "Active" : "InActive"
                                                                                        },
                                                                                        user: user
                                                                                    });
                                                                                }
                                                                            }}
                                                                            activities={{
                                                                                disableDelete: !this.state.activeTeam?.isOwner,
                                                                                onClickDelete: (teamUser) => {
                                                                                    this.deleteUserFromTeam(teamUser.username, teamUser.userFullName, teamUser.id);
                                                                                }
                                                                            }}
                                                                            columns={[
                                                                                { Header: "Name", accessor: "userFullName", width: '35%' },
                                                                                { Header: "Date", accessor: "created_datetime", width: '25%', isDate: true },
                                                                                { Header: "Status", accessor: "status", width: '25%' }
                                                                            ]}
                                                                            data={this.getMemberPaginatedData().map((user) => ({
                                                                                ...user,
                                                                                status: (
                                                                                    <span style={{ color: user.status === "Active" ? "#238E28" : "#DAB90B" }}>
                                                                                        {user.status}
                                                                                    </span>
                                                                                ),
                                                                                isActive: user.status === "Active"
                                                                            }))}
                                                                        />
                                                                    </div>

                                                                    {this.state.teamUsers.length > this.state.pageSize && (
                                                                        <div style={{ zIndex: 1 }}>
                                                                            <TableViewPagination
                                                                                currentPage={this.state.currentPageMembers}
                                                                                totalCount={this.state.teamUsers.length}
                                                                                pageSize={this.state.pageSize}
                                                                                onPageChange={this.handleMemberPageChange}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div style={{
                                                                    position: "relative",
                                                                    height: "auto",
                                                                    overflow: "auto",
                                                                    paddingBottom: '20px',
                                                                    marginBottom: "20px"
                                                                }}>
                                                                    <div className='teams-grid'>
                                                                        {teamUsers.map(teamUser => (
                                                                            <div className='teams-card'
                                                                                style={{ cursor: teamUser.status === "Active" ? "pointer" : "not-allowed" }}
                                                                                onClick={() => {
                                                                                    if (teamUser.status === "Active") {
                                                                                        this.props.history.push("/teams/givenAccess", {
                                                                                            teamUser,
                                                                                            user
                                                                                        });
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {this.state.activeTeam.isOwner && (
                                                                                    <div className='teams-delete-container'>
                                                                                        <img
                                                                                            src={teamsDeleteIcon}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                this.deleteUserFromTeam(teamUser.username, teamUser.userFullName)
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    flexDirection: 'column',
                                                                                    alignItems: "center",
                                                                                }}>
                                                                                    {teamUser.avatarUrl ? (
                                                                                        <img
                                                                                            className='teams-avatar-1'
                                                                                            src={`${teamUser.avatarUrl}?${teamUser.sas_token}`}
                                                                                        />
                                                                                    ) : (
                                                                                        <Avatar
                                                                                            className='teams-avatar-2'
                                                                                            color={
                                                                                                teamUser.status === "Active"
                                                                                                    ? AppConstants.PLANNER.STATUS.COMPLETED
                                                                                                    : teamUser.status === "Inactive"
                                                                                                        ? AppConstants.PLANNER.STATUS.TO_DO
                                                                                                        : AppConstants.PLANNER.STATUS.IN_PROGRESS
                                                                                            }
                                                                                            size={"77px"}
                                                                                            round={true}
                                                                                            name={teamUser.userFullName}
                                                                                        />
                                                                                    )}
                                                                                    <div className='teams-member-name' title={teamUser.userFullName}>
                                                                                        {teamUser.userFullName.length > 20
                                                                                            ? `${teamUser.userFullName.substring(0, 20)} ...`
                                                                                            : teamUser.userFullName}
                                                                                    </div>
                                                                                    <div className='teams-date-created'>
                                                                                        {teamUser.created_datetime
                                                                                            ? dateFormat(teamUser.created_datetime, 'dd mmm yyyy')
                                                                                            : '-'}
                                                                                    </div>
                                                                                    <div className='teams-status-container'>
                                                                                        <img
                                                                                            src={teamUser.status === "Active" ? teamsGreenTick : teamsInvite}
                                                                                            alt='check'
                                                                                        />
                                                                                        <div
                                                                                            className="status"
                                                                                            style={{ color: teamUser.status === "Active" ? "#238E28" : "#DAB90B" }}
                                                                                        >
                                                                                            {teamUser.status}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )
                                                        ) : (
                                                            <div className='empty-data-message' style={{ height: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                <div>
                                                                    <img style={{ height: "250px", width: "225px" }} src={NoTeamMember} />
                                                                    <div style={{ marginTop: "-20px" }}>This team has no members.</div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>



                                            {/* PILOTS SECTION */}


                                            <div style={{ maxHeight: '44vh', height: '44vh', display: 'flex', flexDirection: 'column' }}>
                                                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", textAlign: "center", marginBottom: '20px' }}>
                                                    <div className="teamName total-team-members">
                                                        {`Pilots (${this.state.dronePilotsList.length})`}
                                                    </div>
                                                    <input
                                                        type='file'
                                                        style={{ display: "none" }}
                                                        ref={this.fileInputRef}
                                                        onChange={(e) => {
                                                            this.handleFileChange(e)
                                                        }}
                                                    />
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px" }}>
                                                        {/* comment for now  */}
                                                        {/* <Button
                                                    className={"new-btn-lg"}
                                                    text={"Import Data"}
                                                    isBtnActive
                                                    onClick={()=>{
                                                    this.handleFileImport();
                                                   }}
                                                /> */}
                                                        <Button
                                                            className={"new-btn-lg"}
                                                            text={"Add Pilot"}
                                                            isBtnActive
                                                            onClick={() => {
                                                                this.setState({
                                                                    addPilotModal: true,
                                                                    validationDisplay: "none",
                                                                    validationColor: "red",
                                                                    validationMessage: ""
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                </div>


                                                {this.state.isPilotsLoading ? (
                                                    <div style={{ height: "70vh", display: "flex", textAlign: "center" }}>
                                                        <img src={Loader} style={{ height: "30vh", margin: "auto" }} />
                                                    </div>
                                                ) : (
                                                    <>
                                                        {this.state.dronePilotsList.length > 0 ? (
                                                            this.state.listViewPilot ? (
                                                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                                                    <div
                                                                        style={{ flex: 1, overflowY: 'auto', position: "relative" }}
                                                                        onScroll={(e) => {
                                                                            const menus = document.querySelectorAll('[data-tippy-root]');
                                                                            menus.forEach(menu => menu.remove());
                                                                        }}>
                                                                        <TableView
                                                                            count={this.state.totalDronePilots || this.state.dronePilotsList.length}
                                                                            showSrNo={true}
                                                                            hidePagination
                                                                            onStateChange={() => { }}
                                                                            headingLeft=""
                                                                            activities={{
                                                                                canEdit: true,
                                                                                hideDelete: true,
                                                                                onClickEdit: (pilot) => {
                                                                                    this.setState({
                                                                                        updatePilotModal: true,
                                                                                        pilotId: pilot.id,
                                                                                        pilotName: pilot.pilot_name || "",
                                                                                        pilotMobile: pilot.mobile_no || "",
                                                                                        pilotLicense: pilot.pilot_license_id || "",
                                                                                        initialPilotData: {
                                                                                            name: pilot.pilot_name,
                                                                                            mobile: pilot.mobile_no,
                                                                                            license: pilot.pilot_license_id
                                                                                        }
                                                                                    });
                                                                                }
                                                                            }}

                                                                            columns={[
                                                                                { Header: "Name", accessor: "pilot_name", width: '25%' },
                                                                                { Header: "Mobile Number", accessor: "mobile_no", width: '20%' },
                                                                                { Header: "Pilot License", accessor: "pilot_license_id", width: '25%', Cell: ({ cell }) => cell.value || "—" },
                                                                                {
                                                                                    Header: "Date Added",
                                                                                    accessor: "date_created",
                                                                                    width: '30%',
                                                                                    isDate: true,
                                                                                    Cell: ({ cell }) =>
                                                                                        new Date(cell.value).toLocaleDateString("en-IN", {
                                                                                            day: "2-digit",
                                                                                            month: "short",
                                                                                            year: "numeric",
                                                                                            hour: "2-digit",
                                                                                            minute: "2-digit"
                                                                                        })
                                                                                }
                                                                            ]}
                                                                            data={this.getPilotPaginatedData(this.state.dronePilotsList)}
                                                                        />
                                                                    </div>

                                                                    {/* {(this.state.totalDronePilots || this.state.dronePilotsList.length) > this.state.pageSize && (
                                                                <div style={{ zIndex: 1 }}>
                                                                    <TableViewPagination
                                                                        currentPage={this.state.dronePilotsPageNumber}
                                                                        totalCount={this.state.totalDronePilots}
                                                                        pageSize={this.state.pageSize}
                                                                        onPageChange={this.handlePilotPageChange}
                                                                    />
                                                                </div>
                                                            )} */}
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )
                                                        ) : (
                                                            <div className='empty-data-message' style={{ height: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                <div>
                                                                    <img style={{ height: "250px", width: "225px" }} src={NoTeamMember} />
                                                                    <div style={{ marginTop: "-20px" }}>This team has no members.</div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>

                                        </> : <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", height: "75vh" }}>
                                            {`You dont have access to teams section of ${this.state.team?.teamName} `}
                                        </div>}

                                    <AnimatedModal
                                        isOpen={inviteModal}
                                        onRequestClose={() => {
                                            this.setState((state) => ({
                                                ...state,
                                                inviteModal: false,
                                                inviteMail: "",
                                                validationDisplay: "none",
                                                validationColor: "red",
                                                validationMessage: ""
                                            }))
                                        }}
                                        height="294px"
                                        width="577px"
                                    >
                                        <form onSubmit={this.sendInvite} style={{
                                            padding: "28px"
                                        }}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                height: "237px",
                                                width: "522px"
                                            }}>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "inherit",
                                                    color: "#081425",
                                                    fontSize: "22px",
                                                    fontWeight: 600,
                                                    fontFamily: "Lato"
                                                }}>
                                                    <div>
                                                        Invite User
                                                    </div>
                                                    <img src={closeBtn} alt='i ma close' style={{
                                                        width: "16px",
                                                        height: "16px",
                                                        cursor: "pointer"
                                                    }} onClick={() => {
                                                        this.setState({
                                                            inviteModal: false,
                                                            inviteMail: "",
                                                            validationDisplay: "none",
                                                            validationColor: "red",
                                                            validationMessage: ""
                                                        })
                                                    }} />
                                                </div>
                                                <div style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "flex-start",
                                                    width: "inherit"
                                                }}>
                                                    <div style={{
                                                        textAlign: "left",
                                                        color: "#555C67",
                                                        fontWeight: 500,
                                                        marginBottom: "5px"
                                                    }}>
                                                        Email ID
                                                    </div>
                                                    <input
                                                        onInput={(event) => this.handleInputChange(event, "inviteMail")}
                                                        value={this.state.inviteMail}
                                                        name="username"
                                                        className="teams-text-input"
                                                        placeholder="Email"
                                                        autoFocus
                                                    />
                                                    <div style={{
                                                        textAlign: "left",
                                                        color: validationColor,
                                                        fontSize: "12px",
                                                        height: "20px"
                                                    }}
                                                    >
                                                        {validationMessage}
                                                    </div>
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: "space-between",
                                                    width: "inherit"
                                                }}>
                                                    <Button
                                                        className={"new-btn-lg"}
                                                        text={"Cancel"}
                                                        onClick={() => {
                                                            this.setState({
                                                                inviteModal: false,
                                                                inviteMail: "",
                                                                validationDisplay: "none",
                                                                validationColor: "red",
                                                                validationMessage: ""
                                                            })
                                                        }}
                                                    />
                                                    <Button
                                                        className={"new-btn-lg"}
                                                        text={"Invite"}
                                                        type={"submit"}
                                                        isBtnActive={true}
                                                        onClick={() => {
                                                            this.sendInvite()
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </AnimatedModal>

                                    <AnimatedModal
                                        isOpen={addPilotModal}
                                        onRequestClose={() => {
                                            this.setState((prev) => ({
                                                ...prev,
                                                addPilotModal: false,
                                                inviteMail: "",
                                                validationDisplay: "none",
                                                validationColor: "red",
                                                validationMessage: "",
                                                pilotMobileVerified: false,
                                                tempPilotId: '',
                                                otpError: '',
                                                otp: '',
                                                pilotName: '',
                                                pilotMobile: '',
                                                pilotLicense: '',
                                                errors: {
                                                    name: "",
                                                    mobile: "",
                                                    license: ""
                                                }
                                            }))
                                        }}
                                        height="auto"
                                        width="577px"
                                    >
                                        <form style={{
                                            padding: "28px"
                                        }}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                height: "auto",
                                                width: "522px"
                                            }}>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "inherit",
                                                    color: "#081425",
                                                    fontSize: "22px",
                                                    fontWeight: 600,
                                                    fontFamily: "Lato"
                                                }}>
                                                    <div>
                                                        Add Pilot
                                                    </div>
                                                    <img src={closeBtn} alt='i ma close' style={{
                                                        width: "16px",
                                                        height: "16px",
                                                        cursor: "pointer"
                                                    }} onClick={() => {
                                                        this.setState((prev) => ({
                                                            ...prev,

                                                            addPilotModal: false,
                                                            inviteMail: "",
                                                            validationDisplay: "none",
                                                            validationColor: "red",
                                                            validationMessage: "",
                                                            pilotMobileVerified: false,
                                                            tempPilotId: '',
                                                            otpError: '',
                                                            otp: '',
                                                            pilotName: '',
                                                            pilotMobile: '',
                                                            pilotLicense: '',
                                                            errors: {
                                                                name: "",
                                                                mobile: "",
                                                                license: ""
                                                            }

                                                        }))
                                                    }} />
                                                </div>
                                                <div style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "flex-start",
                                                    width: "inherit"
                                                }}>
                                                    <div style={{}}>
                                                        <div style={{
                                                            textAlign: "left",
                                                            color: "#555C67",
                                                            fontWeight: 500,
                                                            marginBottom: "5px",
                                                            marginTop: "20px"
                                                        }}>
                                                            Name
                                                            <span style={{ marginLeft: "1px", color: "crimson" }}>*</span>
                                                        </div>
                                                        <input
                                                            maxLength={50}
                                                            minLength={3}
                                                            onInput={(event) => {
                                                                const lettersOnly = event.target.value.replace(/[^a-zA-Z\s]/g, '');
                                                                event.target.value = lettersOnly;
                                                                this.handleInputChange(event, "pilotName")
                                                                const error = this.validatePilotName(event.target.value)
                                                                this.setState({
                                                                    errors: {
                                                                        ...this.state.errors,
                                                                        name: error
                                                                    }
                                                                });
                                                            }}
                                                            value={this.state.pilotName}
                                                            name="pilotName"
                                                            className="teams-text-input"
                                                            placeholder="Enter Name"
                                                            autoFocus
                                                        />

                                                        <div style={{ textAlign: "left", marginTop: "3px", fontSize: "12px", color: "crimson" }}>{this.state.errors.name}</div>

                                                    </div>
                                                    {/* Mobile Field */}
                                                    <div style={{ width: "100%", position: "relative" }}> {/* Add position: relative to the container */}
                                                        <div style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                        }}>
                                                            <div style={{
                                                                textAlign: "left",
                                                                color: "#555C67",
                                                                fontWeight: 500,
                                                                marginBottom: "5px",
                                                                marginTop: "20px"
                                                            }}>
                                                                Mobile No. <span style={{ marginLeft: "1px", color: "crimson" }}>*</span>
                                                            </div>
                                                        </div>
                                                        <input
                                                            onInput={(event) => {
                                                                const value = event.target.value.replace(/\D/g, '').slice(0, 10);
                                                                event.target.value = value;
                                                                this.setState({
                                                                    pilotMobile: value,
                                                                    pilotMobileVerified: false // Reset verification if mobile number changes
                                                                }, () => {
                                                                    this.setState({
                                                                        errors: {
                                                                            ...this.state.errors,
                                                                            mobile: this.validateMobile(this.state.pilotMobile)
                                                                        }
                                                                    });
                                                                });
                                                            }}
                                                            value={this.state.pilotMobile}
                                                            className="teams-text-input"
                                                            placeholder="Enter Mobile Number"
                                                            maxLength={10}
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            disabled={this.state.pilotMobileVerified}
                                                            style={{ paddingRight: "80px" }}
                                                        />
                                                        {/* Verification Status - Absolutely positioned */}
                                                        <div style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "75%",
                                                            transform: "translateY(-50%)",
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}>
                                                            {this.state.pilotMobileVerified && (
                                                                <div style={{ color: "green", fontSize: "12px", display: "flex", alignItems: "center" }}>
                                                                    <span>Verified</span>
                                                                    <svg style={{ marginLeft: "5px" }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                                                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                                                    </svg>
                                                                </div>
                                                            )}
                                                            {!this.state.pilotMobileVerified && this.state.pilotMobile?.length === 10 && (
                                                                <span onClick={() => this.handleSendOtp(this.state.pilotMobile)} style={{
                                                                    color: "#007BFF",
                                                                    textDecoration: "underline",
                                                                    cursor: "pointer",
                                                                    fontSize: "14px"
                                                                }}>
                                                                    Verify
                                                                </span>
                                                            )}

                                                        </div>
                                                        <div style={{ textAlign: "left", marginTop: "3px", fontSize: "12px", color: "crimson" }}>
                                                            {this.state.errors.mobile}
                                                        </div>
                                                    </div>

                                                    <div >
                                                        <div style={{
                                                            textAlign: "left",
                                                            color: "#555C67",
                                                            fontWeight: 500,
                                                            marginBottom: "5px",
                                                            marginTop: "20px"
                                                        }}>
                                                            License
                                                            <span style={{ marginLeft: "2px", fontSize: "14px", color: "gray" }}>(optional)</span>
                                                        </div>
                                                        <input
                                                            maxLength={15}
                                                            onInput={(event) => {
                                                                const alphanumericValue = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
                                                                event.target.value = alphanumericValue;
                                                                this.handleInputChange(event, "pilotLicense")
                                                                const error = this.validateLicense(event.target.value);
                                                                this.setState({
                                                                    errors: {
                                                                        ...this.state.errors,
                                                                        license: error
                                                                    }
                                                                });
                                                            }}
                                                            value={this.state.pilotLicense}
                                                            name="pilotLicense"
                                                            className="teams-text-input"
                                                            placeholder="Enter License"
                                                        />
                                                        <div style={{ textAlign: "left", marginTop: "3px", fontSize: "12px", color: "crimson" }}>{this.state.errors.license}</div>
                                                    </div>

                                                    <div style={{
                                                        textAlign: "left",
                                                        color: validationColor,
                                                        fontSize: "12px",
                                                        height: "20px"
                                                    }}
                                                    >
                                                        {validationMessage}
                                                    </div>
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: "space-between",
                                                    width: "inherit",
                                                    marginTop: "20px"
                                                }}>
                                                    <Button
                                                        className={"new-btn-lg"}
                                                        text={"Cancel"}
                                                        onClick={() => {
                                                            this.setState({
                                                                addPilotModal: false,
                                                                inviteMail: "",
                                                                validationDisplay: "none",
                                                                validationColor: "red",
                                                                validationMessage: "",
                                                                pilotMobileVerified: false,
                                                                tempPilotId: '',
                                                                otpError: '',
                                                                otp: '',
                                                                pilotName: '',
                                                                pilotMobile: '',
                                                                pilotLicense: '',
                                                                errors: {
                                                                    name: "",
                                                                    mobile: "",
                                                                    license: ""
                                                                }
                                                            })
                                                        }}
                                                    />
                                                    <Button
                                                        className={"new-btn-lg"}
                                                        text={"Add"}
                                                        type={"submit"}
                                                        isDisabled={!this.isFormFilled()}
                                                        isBtnActive={true}
                                                        onClick={() => {
                                                            this.handleAddPilotSubmit()
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                        </form>
                                    </AnimatedModal>

                                    <AnimatedModal
                                        isOpen={this.state.updatePilotModal}
                                        onRequestClose={() => {
                                            this.setState({
                                                updatePilotModal: false,
                                                pilotName: "",
                                                pilotMobile: "",
                                                pilotLicense: "",
                                                validationMessage: "",
                                                updateFormErrors: {
                                                    name: "",
                                                    mobile: "",
                                                    license: ""
                                                },
                                                otpError: '',
                                                pilotMobileVerified: false,
                                                showOtpModal: false,
                                                otp: '',
                                                isMobileChanged: false,
                                                tempPilotId: '',
                                                isSendingOtp: false,
                                                isVerifyingOtp: false
                                            });
                                        }}
                                        height="auto"
                                        width="577px"
                                    >
                                        <form style={{ padding: "28px" }}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                height: "auto",
                                                width: "522px"
                                            }}>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "inherit",
                                                    color: "#081425",
                                                    fontSize: "22px",
                                                    fontWeight: 600,
                                                    fontFamily: "Lato"
                                                }}>
                                                    <div>Update Pilot</div>
                                                    <img
                                                        src={closeBtn}
                                                        alt='close'
                                                        style={{
                                                            width: "16px",
                                                            height: "16px",
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={() => {
                                                            this.setState({
                                                                updatePilotModal: false,
                                                                pilotName: "",
                                                                pilotMobile: "",
                                                                pilotLicense: "",
                                                                validationMessage: "",
                                                                updateFormErrors: {
                                                                    name: "",
                                                                    mobile: "",
                                                                    license: ""
                                                                },
                                                                otpError: '',
                                                                pilotMobileVerified: false,
                                                                showOtpModal: false,
                                                                otp: '',
                                                                isMobileChanged: false,
                                                                tempPilotId: '',
                                                                isSendingOtp: false,
                                                                isVerifyingOtp: false
                                                            });
                                                        }}
                                                    />
                                                </div>

                                                {/* Name Field */}
                                                <div style={{ width: "100%", marginTop: "20px" }}>
                                                    <div style={{
                                                        textAlign: "left",
                                                        color: "#555C67",
                                                        fontWeight: 500,
                                                        marginBottom: "5px"
                                                    }}>
                                                        Name <span style={{ color: "crimson" }}>*</span>
                                                    </div>
                                                    <input
                                                        maxLength={50}
                                                        minLength={3}
                                                        onInput={(event) => {
                                                            const lettersOnly = event.target.value.replace(/[^a-zA-Z\s]/g, '');
                                                            event.target.value = lettersOnly;
                                                            this.setState({ pilotName: lettersOnly }, () => {
                                                                this.setState({
                                                                    updateFormErrors: {
                                                                        ...this.state.updateFormErrors,
                                                                        name: this.validatePilotName(this.state.pilotName)
                                                                    }
                                                                });
                                                            });
                                                        }}
                                                        value={this.state.pilotName}
                                                        className="teams-text-input"
                                                        placeholder="Enter Name"
                                                        autoFocus
                                                    />
                                                    <div style={{
                                                        textAlign: "left",
                                                        marginTop: "3px",
                                                        fontSize: "12px",
                                                        color: "crimson",
                                                        height: "15px"
                                                    }}>
                                                        {this.state.updateFormErrors.name}
                                                    </div>
                                                </div>

                                                {/* Mobile Field */}
                                                <div style={{ width: "100%", position: "relative" }}>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}>
                                                        <div style={{
                                                            textAlign: "left",
                                                            color: "#555C67",
                                                            fontWeight: 500,
                                                            marginBottom: "5px"
                                                        }}>
                                                            Mobile No. <span style={{ color: "crimson" }}>*</span>
                                                        </div>
                                                    </div>
                                                    <input
                                                        onInput={(event) => {
                                                            const value = event.target.value.replace(/\D/g, '').slice(0, 10);
                                                            event.target.value = value;
                                                            const isChanged = value !== this.state.initialPilotData.mobile;
                                                            this.setState({
                                                                pilotMobile: value,
                                                                isMobileChanged: isChanged,
                                                                pilotMobileVerified: isChanged ? false : this.state.pilotMobileVerified
                                                            }, () => {
                                                                this.setState({
                                                                    updateFormErrors: {
                                                                        ...this.state.updateFormErrors,
                                                                        mobile: this.validateMobile(this.state.pilotMobile)
                                                                    }
                                                                });
                                                            });
                                                        }}
                                                        disabled={this.state.pilotMobileVerified}
                                                        value={this.state.pilotMobile}
                                                        className="teams-text-input"
                                                        placeholder="Enter Mobile Number"
                                                        maxLength={10}
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                    />
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}>
                                                        {this.state.pilotMobileVerified && (
                                                            <div style={{ color: "green", fontSize: "12px", display: "flex", alignItems: "center" }}>
                                                                <span>Verified</span>
                                                                <svg style={{ marginLeft: "5px" }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                                                </svg>
                                                            </div>
                                                        )}
                                                        {!this.state.pilotMobileVerified && this.state.pilotMobile !== this.state.initialPilotData.mobile && this.state.pilotMobile?.length === 10 && (
                                                            <span onClick={() => this.handleSendOtp(this.state.pilotMobile, this.state.pilotId)} style={{
                                                                color: "#007BFF",
                                                                textDecoration: "underline",
                                                                cursor: "pointer",
                                                                fontSize: "14px"
                                                            }}>
                                                                Verify
                                                            </span>
                                                        )}

                                                    </div>
                                                    <div style={{
                                                        textAlign: "left",
                                                        marginTop: "3px",
                                                        fontSize: "12px",
                                                        color: "crimson",
                                                        height: "15px"
                                                    }}>
                                                        {this.state.updateFormErrors.mobile}

                                                    </div>

                                                </div>

                                                {/* License Field */}
                                                <div style={{ width: "100%", marginTop: "20px" }}>
                                                    <div style={{
                                                        textAlign: "left",
                                                        color: "#555C67",
                                                        fontWeight: 500,
                                                        marginBottom: "5px"
                                                    }}>
                                                        License <span style={{ fontSize: "14px", color: "gray" }}>(optional)</span>
                                                    </div>
                                                    <input
                                                        maxLength={15}
                                                        onInput={(event) => {
                                                            const alphanumericValue = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
                                                            event.target.value = alphanumericValue;
                                                            this.setState({ pilotLicense: alphanumericValue }, () => {
                                                                this.setState({
                                                                    updateFormErrors: {
                                                                        ...this.state.updateFormErrors,
                                                                        license: this.validateLicense(this.state.pilotLicense)
                                                                    }
                                                                });
                                                            });
                                                        }}
                                                        value={this.state.pilotLicense}
                                                        className="teams-text-input"
                                                        placeholder="Enter License"
                                                    />
                                                    <div style={{
                                                        textAlign: "left",
                                                        marginTop: "3px",
                                                        fontSize: "12px",
                                                        color: "crimson",
                                                        height: "15px"
                                                    }}>
                                                        {this.state.updateFormErrors.license}
                                                    </div>
                                                </div>

                                                {/* Validation Message */}
                                                <div style={{
                                                    textAlign: "left",
                                                    color: this.state.validationColor,
                                                    fontSize: "12px",
                                                    height: "20px",
                                                    width: "100%",
                                                    marginTop: "10px"
                                                }}>
                                                    {this.state.validationMessage}
                                                </div>

                                                {/* Buttons */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: "space-between",
                                                    width: "inherit",
                                                    marginTop: "20px"
                                                }}>
                                                    <Button
                                                        className={"new-btn-lg"}
                                                        text={"Cancel"}
                                                        onClick={() => {
                                                            this.setState({
                                                                updatePilotModal: false,
                                                                pilotName: "",
                                                                pilotMobile: "",
                                                                pilotLicense: "",
                                                                validationMessage: "",
                                                                errors: {
                                                                    name: "",
                                                                    mobile: "",
                                                                    license: ""
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    <Button
                                                        className={"new-btn-lg"}
                                                        text={"Update"}
                                                        isDisabled={!this.canUpdatePilot()}
                                                        isBtnActive={true}
                                                        onClick={(e) => {
                                                            this.handlePilotUpdate();
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </AnimatedModal>

                                    {/* OTP Verification Modal */}
                                    <AnimatedModal
                                        isOpen={this.state.showOtpModal}
                                        onRequestClose={() => this.setState({ showOtpModal: false, otp: '', otpError: '' })}
                                        height="auto"
                                        width="400px"
                                    >
                                        <div style={{ padding: "28px" }}>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                width: "100%",
                                                color: "#081425",
                                                fontSize: "18px",
                                                fontWeight: 600,
                                                fontFamily: "Lato",
                                                marginBottom: "20px"
                                            }}>
                                                <div>Verify Mobile Number</div>
                                                <img
                                                    src={closeBtn}
                                                    alt='close'
                                                    style={{ width: "16px", height: "16px", cursor: "pointer" }}
                                                    onClick={() => this.setState({ showOtpModal: false, otp: '', otpError: '' })}
                                                />
                                            </div>

                                            <div style={{ marginBottom: "15px" }}>
                                                <div style={{ marginBottom: "10px", fontSize: "14px" }}>Enter OTP sent to {this.state.pilotMobile}</div>
                                                <input
                                                    type="text"
                                                    value={this.state.otp}
                                                    onChange={(e) => this.setState({
                                                        otp: e.target.value.replace(/\D/g, '').slice(0, 6),
                                                        otpError: '' // Clear error when user types
                                                    })}
                                                    className="teams-text-input"
                                                    placeholder="Enter 6-digit OTP"
                                                    maxLength={6}
                                                />
                                                {/* OTP Error Message */}
                                                <div style={{
                                                    textAlign: "left",
                                                    marginTop: "3px",
                                                    fontSize: "12px",
                                                    color: "crimson",
                                                    height: "15px"
                                                }}>
                                                    {this.state.otpError}
                                                </div>
                                            </div>

                                            <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                                                <Button
                                                    className={"new-btn-lg"}
                                                    text={"Verify"}
                                                    isBtnActive={true}
                                                    isDisabled={this.state.otp.length !== 6 || this.state.isVerifyingOtp}
                                                    onClick={() => this.handleVerifyOtp(this.state.otp, this.state.tempPilotId)}
                                                />
                                            </div>
                                        </div>
                                    </AnimatedModal>
                                </div>
                            }
                        </div>
                    </div > : <div />
                }
            </>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateProfileDetails: (payload) => dispatch(updateProfileDetails(payload))
    };
};

const mapStateToProps = state => {
    return {
        isLoggedInUserOwner: state.profile.isLoggedInUserOwner,
        SubscriptionData: state.subscription.subscriptionData,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AeroGCSEnterpriseTeam);